///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users = abcsetup.users || {};
abcsetup.users.create = abcsetup.users.create || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users.create = {
    init: function() {
        abcsetup.setTitle('Create User');

        var country  = "select[name='addr_country']";
        var province = "select[name='addr_province']";
        var city     = "input[name='addr_city']";

        abcsetup.users.common.init();

        // update province from country
        $(country).change(function() {
            $(province).empty();

            axios.post('/api/autocomplete/geoProvince', {country: $(country).val()}).then(response => {
                result = response['data'];

                if (result.length > 0) {
                    for (var idx in result) {
                        $('<option />', {value: result[idx], text: result[idx]}).appendTo($(province));
                    }
                }
            });
        }).trigger("change");

        /*
        // auto-complete city select list from country and province
        // FIXME: must load US city data
        // I doubt we even need this
        $(city).autoComplete({
            resolver: 'custom',
            events: {
                search: function (qry, callback) {
                    axios.post('/api/autocomplete/geoCity',{
                        country: $(country).val(),
                        province: $(province).val(),
                        city : qry
                    }).then(response => {
                        result  = response['data'];
                        if (result.length > 0 ) {
                            console.log('result: ',result);
                            callback(result);
                        }
                    });
                }
            }
        });
        */
    },
}
